import { useVault } from '../context/VaultContext';

/** Returns the vault-aware display label for the "platform" field (e.g. "Platform", "Brand"). */
export function usePlatformLabel(): string {
  const { vaultTypeDef } = useVault();
  return vaultTypeDef?.platformLabel ?? 'Platform';
}
